<script setup>
defineProps({
  content: {
    type: Object,
    required: true,
    default() {
      return {}
    },
  },
})
</script>

<template>
  <section class="relative w-full">
    <BaseContainer class="relative z-10 my-10 lg:my-20" size="md">
      <div
        class="relative flex flex-col flex-wrap items-center justify-between overflow-hidden rounded-2xl p-6 text-center sm:p-12 lg:rounded-3xl"
        :class="{
          'bg-primary': content?.style === 'Primary',
          'bg-secondary': content?.style === 'Secondary',
          'bg-gray-100': content?.style === 'Tertiary',
          'bg-white': content?.style === 'White',
        }"
      >
        <div class="lg:max-w-1/2 relative z-10">
          <header v-if="content?.title" class="mb-6">
            <h2
              class="text-4xl-nlh uppercase leading-verytight lg:text-7xl-nlh"
              :class="{
                'text-secondary': ['Primary', 'White', 'Tertiary'].includes(
                  content?.style,
                ),
                'text-primary': content?.style === 'Secondary',
              }"
            >
              {{ content?.title }}
            </h2>
          </header>
        </div>
        <div
          v-if="content?.buttons"
          class="relative z-10 flex flex-wrap justify-center gap-3 sm:gap-5"
        >
          <Button
            v-for="button in content?.buttons"
            :key="button.id"
            :theme="button?.style.toLowerCase() || 'primary'"
            :path="button?.url"
            :aria-label="button?.title"
            :text="button?.title"
          />
        </div>
      </div>
    </BaseContainer>
  </section>
</template>
